<template>
  <div>
    <dl class="description-list grid-x grid-margin-x max-w-sm text-base mt-4 md:mt-0">
      <dt class="cell small-6" v-html="bp('textOrderNumber')" />
      <dd class="cell small-6" v-html="orderData.code" />

      <dt class="cell small-6" v-html="bp('textPoNumber')" />
      <dd class="cell small-6" v-html="orderData.details.customerPo" />

      <dt class="cell small-6" v-html="bp('textOrderDate')" />
      <dd class="cell small-6" v-html="orderData.details.orderDate" />

      <dt class="cell small-6" v-html="bp('textRequestDate')" />
      <dd class="cell small-6" v-html="orderData.details.requestedDate" />

      <dt class="cell small-6" v-html="bp('textPlacedBy')" />
      <dd class="cell small-6" v-html="orderData.details.placedBy" />

      <dt class="cell small-6" v-html="bp('textPaymentTerms')" />
      <dd class="cell small-6" v-html="orderData.details.paymentTerms" />

      <dt class="cell small-6" v-html="bp('textOrderStatus')" />
      <dd class="cell small-6" v-html="orderData.details.orderStatus" />

      <dt class="cell small-6" v-html="bp('textItemsShipped')" />
      <dd class="cell small-6" v-html="orderData.details.shippedQuantity" />

      <dt class="cell small-6" v-html="bp('textBillingAddress')" />
      <dd class="cell small-6">
        <div v-show="orderData.billingAddress.billTo" v-html="orderData.billingAddress.billTo" />
        <div v-show="orderData.billingAddress.billingNumber" v-html="orderData.billingAddress.billingNumber" />
        <div v-show="orderData.billingAddress.line1" v-html="orderData.billingAddress.line1" />
      </dd>
    </dl>
    <dl
      v-if="orderData.details.isConsumerDelivery && orderData.consumerDetails"
      class="description-list grid-x grid-margin-x max-w-sm text-base"
    >
      <dt class="cell small-6" v-html="bp('textConsumerName')" />
      <dd class="cell small-6" v-html="orderData.consumerDetails.name" />

      <dt class="cell small-6" v-html="bp('textPhoneNumber')" />
      <dd class="cell small-6" v-html="orderData.consumerDetails.phoneNumber" />

      <dt class="cell small-6" v-html="bp('textConsumerEmail')" />
      <dd class="cell small-6" v-html="orderData.consumerDetails.email" />

      <dt class="cell small-6" v-html="bp('textConsumerDeliveryAddress')" />
      <dd class="cell small-6">
        <div v-show="orderData.consumerDetails.line1" v-html="orderData.consumerDetails.line1" />
        <div v-show="orderData.consumerDetails.line2" v-html="orderData.consumerDetails.line2" />
        <div v-show="orderData.consumerDetails.town" v-html="orderData.consumerDetails.town" />
        <div v-show="orderData.consumerDetails.regionIso" v-html="orderData.consumerDetails.regionIso" />
        <div v-show="orderData.consumerDetails.postalCode" v-html="orderData.consumerDetails.postalCode" />
      </dd>
    </dl>
  </div>
</template>

<script>
export default {
  props: {
    orderData: {
      type: Object,
      required: true,
      default: () => {},
    },
    baseProperties: {
      type: Array,
      default() {
        return [];
      },
    },
  },
  data() {
    return {};
  },
};
</script>
